export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement7.4608435f.png";